export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6269.d2c0a749.jpg";